import React from 'react';
import { FsComponentSize } from 'globals/types';
import FsSimpleTable from 'ui-elements/tables/FsSimpleTable';
import { FinancialMarkersRowInstance } from 'models/report/financial-markers/financial-markers-row';
import { getTableProps } from './MarkersTable.utils';

interface MarkersTableProps {
  rows: FinancialMarkersRowInstance[];
}

const MarkersTable: React.FC<MarkersTableProps> = ({ rows }) => {
  const singleTableProps = getTableProps(rows);
  return <FsSimpleTable {...singleTableProps} rowSize={FsComponentSize.XS} />;
};

export default MarkersTable;
